
import {ref,watch} from 'vue'
import {useStore} from 'vuex'
import deBounce from '../../foundation/js/deBounce'


export default {
    name: "QuickSearch",
    props: {
        excelHelpLink:{
            required: false,
            type: String
        }
    },
    setup(props){
        const store = useStore()
        const searchString = ref(store.state.productSearch.search_string)
        const clipboardSearch = ref("")
        const excelHelpLink = props.excelHelpLink
        const copyError = ref(false)

        const clearSearch = function(){
            store.commit('productSearch/set_search_string','')
            searchString.value = ''
            store.dispatch('productSearch/performSearch', {searchString: "?q=&take=10"})
        }

        const getLabel = (labelRequested) => {
            return store.getters['labels/getLabel'](labelRequested)
        }
        
        watch(searchString,(newString)=>{
            searchNow(newString)
        })

        const searchNow = deBounce((searchString)=>{
            if(searchString.length > 0){
                store.dispatch('productSearch/performStringSearch',{
                    searchString: searchString
                })
                return false
            }
            else {
                store.dispatch('productSearch/performSearch',{searchString: "?q=&take=10"})
            }
            store.commit('productSearch/set_products',[])
        },500)

        const copyFromClipboard = async () => {
            copyError.value = false;           
            try {
                if (!navigator.clipboard) {
                    copyError.value = true;
                    return;
                }

                clipboardSearch.value = await navigator.clipboard.readText();

                const isValid = clipboardSearch.value.trim().split('\n').every(line => /^\d+$/.test(line.trim()));
                
                if (isValid) {
                    store.dispatch('productSearch/performExcelSearch', { searchString: `${clipboardSearch.value}`})
                }
                else {
                    copyError.value = true;
                } 
            } catch (err) {
                copyError.value = true;
                console.error('Failed to read clipboard contents: ', err);
            }
        }
        
        return {
            searchString,
            getLabel,
            clearSearch,
            searchNow,
            copyFromClipboard,
            clipboardSearch,
            excelHelpLink,
            copyError
        }
    },
}